import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  DeletSweetAlert,
  selectFormStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { IoClose } from "react-icons/io5";
import Select from "react-select";
import {
  apiHeader,
  deleteData,
  getData,
  postData,
} from "../../helpers/ApiHelper";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;
const entityNameRegex = /^(?:[A-Z][a-z]+|\b[A-Z]{2,}\b)(?:\s[A-Z][a-z]+|\s\b[A-Z]{2,}\b)*$/;
// const gstRegex = /^(?:\d{11}|\d{9}RT\d{4}|GB\d{9,12}|\d{15}|[A-Z0-9]{8,12})$/;
const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;

// Formik InitialValues
const initialValues = {
  entityName: "",
  typeOfBusiness: "",
  panOfBusiness: "",
  gstNumber: "",
  // country: "",
  state: "",
  address: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  entityName: Yup.string()
    .trim()
    .required("Entity name is required")
    .matches(entityNameRegex, "Entity name is not valid"),
  typeOfBusiness: Yup.string().trim().required("Select type of business"),
  panOfBusiness: Yup.string()
    .trim()
    .required("Pan number is required")
    .matches(/^([A-Z]{5}[0-9]{4}[A-Z]{1})$/, "Pan number is not valid"),
  gstNumber: Yup.string()
    .trim()
    .required("GSTIN number is required")
    .matches(gstRegex, "GSTIN number is not valid"),
  state: Yup.string().trim().required("Select state"),
  // country: Yup.string().trim().required("Select Country"),
  address: Yup.string().trim().required("Address is required"),
});

const TaxIdentificationNumber = () => {
  ChangeTitle("My Tax Identification");

  const [loading, setLoading] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [bisunessTypeList, setBusinessTypeList] = useState([]);
  const [gstList, setGstList] = useState([]);

  // Add GST Api Call
  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        entityName: values.entityName,
        typeOfBusinessId: values.typeOfBusiness,
        panOfBusiness: values.panOfBusiness,
        gstinNumber: values.gstNumber,
        state: values.state,
        address: values.address,
      };

      const response = await postData(
        "private/user/taxidentificationnumber",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          viewGstList();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // GST Detail API Call
  const viewGstList = async () => {
    const param = {};
    var response = await getData(
      "private/user/taxidentificationnumber/detail",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setGstList(data);
      if (data.length != 0) {
        const values = response.data.data[0];
        formik.setValues({
          entityName: values.entityName,
          typeOfBusiness:
            values.typeOfBusinessDetail && values.typeOfBusinessDetail._id,
          panOfBusiness: values.panOfBusiness,
          gstNumber: values.gstinNumber,
          country: values.country,
          state: values.state,
          address: values.address,
        });
      }
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // GST Delete API Call
  const deleteGstDetail = async (id) => {
    const result = await DeletSweetAlert();
    if (result.isConfirmed) {
      const param = {
        taxIndentificationNumberId: id,
      };
      console.log(param, "param");

      var response = await deleteData(
        "private/user/taxidentificationnumber/delete",
        param,
        apiHeader(false)
      );
      console.log(response);

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.message);
        viewGstList();
        formik.resetForm();
      } else {
        console.log(response.data);
        console.log(response.data.message);
      }
    }
  };

  // Business Type List  API Call
  const viewBusinessTypeList = async () => {
    const param = {};
    var response = await getData(
      "private/typeofbusiness/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.typeOfBusiness,
        };
      });
      setBusinessTypeList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // County List  API Call
  const viewCountryList = async () => {
    const param = {};
    var response = await postData(
      "country/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.countryName,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // State List  API Call
  const viewStateList = async (id) => {
    const param = {
      countryId: id,
    };
    var response = await postData(
      "private/state/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.stateName,
        };
      });
      setStateList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewGstList();
    viewCountryList();
    viewBusinessTypeList();
    viewStateList();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Tax identification number
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="flex flex-col lg:flex-row justify-center gap-[3rem]">
            <div className="lg:w-[50%] p-[3rem] form-box">
              <form onSubmit={formik.handleSubmit}>
                <div className="w-full grid grid-cols-1 gap-[2rem] gap-y-[2rem] mb-[5rem]">
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Legal name of the entity
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter legal name of the entity"
                      name="entityName"
                      id="entityName"
                      value={formik.values.entityName}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.entityName && formik.errors.entityName && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.entityName}</div>
                      </div>
                    )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Type of business
                    </label>
                    <Select
                      name="typeOfBusiness"
                      id="typeOfBusiness"
                      placeholder="Select type of business"
                      className="w-full form-select form-input"
                      isSearchable={true}
                      options={bisunessTypeList}
                      value={
                        bisunessTypeList.find(
                          (item) => item.value === formik.values.typeOfBusiness
                        ) || ""
                      }
                      onChange={(e) =>
                        formik.setFieldValue("typeOfBusiness", e.value)
                      }
                      styles={selectFormStyle}
                    />
                    {formik.touched.typeOfBusiness &&
                      formik.errors.typeOfBusiness && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.typeOfBusiness}</div>
                        </div>
                      )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Individual tax identification number  / Permanent account number (PAN)
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter individual tax identification number / permanent account number (PAN)"
                      name="panOfBusiness"
                      id="panOfBusiness"
                      value={formik.values.panOfBusiness}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.panOfBusiness &&
                      formik.errors.panOfBusiness && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.panOfBusiness}</div>
                        </div>
                      )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Business tax identification number  / GSTIN / VAT number / manage
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter business tax identification number  / GSTIN / VAT number / manage"
                      name="gstNumber"
                      id="gstNumber"
                      value={formik.values.gstNumber}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.gstNumber && formik.errors.gstNumber && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.gstNumber}</div>
                      </div>
                    )}
                  </div>
                  {/* <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label required mb-4"
                >
                  Country
                </label>
                <Select
                  name="country"
                  id="country"
                  placeholder="Select Country"
                  className="w-full form-select form-input"
                  isSearchable={true}
                  options={countryList}
                  value={countryList.find(
                    (item) => item.value === formik.values.country
                  )}
                  onChange={(e) => formik.setFieldValue("country", e.value)}
                  styles={selectFormStyle}
                />
                {formik.touched.country && formik.errors.country && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.country}</div>
                  </div>
                )}
              </div> */}
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      State
                    </label>
                    <Select
                      name="state"
                      id="state"
                      placeholder="Select state"
                      className="w-full form-select form-input"
                      isSearchable={true}
                      options={stateList}
                      value={
                        stateList.find(
                          (item) => item.value === formik.values.state
                        ) || ""
                      }
                      onChange={(e) => formik.setFieldValue("state", e.value)}
                      styles={selectFormStyle}
                    />
                    {formik.touched.state && formik.errors.state && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.state}</div>
                      </div>
                    )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Address
                    </label>
                    <input
                      className="w-full form-input"
                      type="text"
                      placeholder="Enter address"
                      name="address"
                      id="address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.address && formik.errors.address && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.address}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w-full justify-center gap-5 flex">
                  <button
                    type="submit"
                    className="btn-submit"
                    disabled={loading}
                  >
                    {!loading && <>{gstList.length != 0 ? "Update" : "Save"}</>}
                    {loading && (
                      <div className="flex items-center gap-3">
                        <span className="" style={{ display: "block" }}>
                          Please wait...{" "}
                        </span>
                        <ClipLoader
                          color={"#ffffff"}
                          loading={loading}
                          size={20}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxIdentificationNumber;
